<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">完善个人信息</span>
    </navbar>
    <div class="page-content">
      <form @submit.prevent="submitHandler" novalidate="novalidate">
        <div class="group-title">实名信息</div>
        <div class="cell-group">
          <div class="input-cells">
            <div class="label-cell">
              <label>真实姓名</label>
            </div>
            <div class="input-cell">
              <input type="text" v-model="name" class="form-control">
            </div>
          </div>
          <div class="input-cells">
            <div class="label-cell">
              <label>身份证号</label>
            </div>
            <div class="input-cell">
              <input type="text" v-model="idcard" class="form-control">
            </div>
          </div>
        </div>
        <div class="btn-group">
          <button type="submit" class="btn-submit">保存</button>
        </div>
      </form>
    </div>
    <spinner :show="loading"></spinner>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'
  import Toast from 'components/toast/toast'

  export default {
    data () {
      return {
        loading: false,
        toastShow: false,
        toastText: '',
        name: '',
        idcard: ''
      }
    },
    components: {
      Navbar,
      Spinner,
      Toast
    },
    created () {
      this.token = this.$cache.getUserToken()
      this._fetchData()
    },
    methods: {
      _fetchData () {
        let vm = this
        let time = Date.now()
        this.loading = true
        this.$ajax({
          url: '/common/getUserInfoByCommon.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time: time,
            sign: vm.$md5(vm.token.uid + time + '1' + vm.token.mac)
          },
          done (info) {
            vm.name = info.name
            vm.idcard = info.idcard
          },
          fail (m) {
            vm.$dialog(m)
          },
          always () {
            vm.loading = false
          }
        })
      },
      _validate () {
        if (!this.name) {
          this.toastText = '请输入真实姓名'
          return !(this.toastShow = true)
        }
        if (!this.idcard) {
          this.toastText = '请输入身份证号'
          return !(this.toastShow = true)
        }
        return true
      },
      submitHandler () {
        if (this._validate()) {
          let vm = this
          let time = Date.now()
          this.loading = true
          this.$ajax({
            url: '/common/selfImprovement.jhtml',
            params: {
              name: vm.name,
              idcard: vm.idcard,
              uid: vm.token.uid,
              mac: vm.token.mac,
              time: time,
              sign: vm.$md5(vm.token.uid + time + '1' + vm.token.mac)
            },
            done (o, p, r) {
              vm.$dialog({
                content: r.msg,
                onHide () {
                  vm.$router.replace('/user')
                }
              })
            },
            fail (m) {
              vm.$dialog(m)
            },
            always () {
              vm.loading = false
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .cell-group
    box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

  .group-title
    margin px2rem(18) 0 px2rem(15) 1em
    font-size px2rem(24)
    color #275482

  .btn-group
    margin-top px2rem(60)
    width 80%
    margin-left 10%
    .btn-submit
      width 100%
      height px2rem(80)
      font-size px2rem(32)
      color #fff
      border none
      border-radius px2rem(8)
      background-color #60c9c8
      box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)
</style>



// WEBPACK FOOTER //
// profile.vue?3fd56180